
import { cn } from "../lib/utils";

import { 

  Listbox as HeadlessListbox, 

  ListboxButton as HeadlessListboxButton, 

  ListboxOption as HeadlessListboxOption, 

  ListboxOptions as HeadlessListboxOptions, 

  ListboxSelectedOption as HeadlessListboxSelectedOption

} from "@headlessui/react";

function Listbox( { ...props } ) {

  return <HeadlessListbox { ...props } />

}

function ListboxButton( { className, ...props } ) {
  
  return (

    <HeadlessListboxButton

      className={ cn(

        "flex items-center justify-between w-full max-w-100 h-10 sm:h-13 px-3 sm:px-5 text-sm sm:text-base bg-grey-abalaster hover:bg-grey-mercury border border-input text-black transition-all",

        "outline-none focus-visible:ring-[2px] focus-visible:border-blue-fresh focus-visible:ring-blue-fresh/50 aria-invalid:ring-red/20 aria-invalid:border-red",

        className

      ) }

      { ...props } 

    />

  )

}

function ListboxOption( { className, ...props } ) {

  return (

    <HeadlessListboxOption

      className={ cn(

        "group flex cursor-default items-center gap-2 px-3 py-1.5 select-none data-focus:bg-grey-mercury text-black", 

        className

      ) }

      { ...props } 

    />

  )

}

function ListboxOptions( { className, ...props } ) {

  return (

    <HeadlessListboxOptions
    
      anchor="bottom"

      className={ cn(

        "w-(--button-width) p-1 mt-2 bg-grey-abalaster border border-input focus:outline-none transition duration-100 ease-in data-leave:data-closed:opacity-0", 

        className

      ) }

      { ...props } 

    />

  )

}

function ListboxSelectedOption( { ...props } ) {

  return <HeadlessListboxSelectedOption { ...props } />

}

export { 

  Listbox,
  
  ListboxButton,

  ListboxOption,

  ListboxOptions,

  ListboxSelectedOption,

}
